import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "password-wrapper position-relative" }
const _hoisted_8 = { class: "strength-bar" }
const _hoisted_9 = { class: "input-error" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group mb-4" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "password-wrapper position-relative" }
const _hoisted_14 = {
  key: 0,
  class: "input-error"
}
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "form-group d-flex gap-3 align-items-center" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "d-flex align-items-center justify-content-center py-1" }
const _hoisted_19 = {
  key: 0,
  class: "material-symbols-outlined text-white fs-20 me-2"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_22 = {
  key: 3,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label text-secondary" }, "Nueva Contraseña", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control h-45 text-dark",
                    autocomplete: "false",
                    placeholder: "Ingrese su nueva contraseña",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userPasswordReset.newPassword) = $event)),
                    onInput: _cache[1] || (_cache[1] = ($event: any) => {_ctx.clearError('newPassword');_ctx.checkStrength()})
                  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelText, _ctx.userPasswordReset.newPassword]
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("i", {
                    style: {"color":"#a9a9c8","font-size":"16px","right":"15px"},
                    class: "ri-eye-off-line password-toggle-icon translate-middle-y top-50 position-absolute",
                    "aria-hidden": "true"
                  }, null, -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["strength", _ctx.strengthClass]),
                      style: _normalizeStyle({ width: _ctx.strengthPercent + '%' })
                    }, null, 6 /* CLASS, STYLE */)
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errors.newPassword), 1 /* TEXT */)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label text-secondary" }, "Confirmar contraseña", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control h-45 text-dark",
                    autocomplete: "false",
                    placeholder: "Confirme su nueva contraseña",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userPasswordReset.confirmPassword) = $event)),
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('confirmPassword')))
                  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelText, _ctx.userPasswordReset.confirmPassword]
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("i", {
                    style: {"color":"#a9a9c8","font-size":"16px","right":"15px"},
                    class: "ri-eye-off-line password-toggle-icon translate-middle-y top-50 position-absolute",
                    "aria-hidden": "true"
                  }, null, -1 /* HOISTED */)),
                  (_ctx.errors.confirmPassword)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errors.confirmPassword), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.isLoading,
                class: "btn btn-primary py-2 px-4 fw-medium fs-16"
              }, [
                _createElementVNode("div", _hoisted_18, [
                  (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_19, " autorenew "))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Cambiar contraseña"))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Procesando..."))
                    : _createCommentVNode("v-if", true)
                ])
              ], 8 /* PROPS */, _hoisted_17)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}